// extracted by mini-css-extract-plugin
export default {"cover":"styles_cover__nTRhy","card":"styles_card__FpycV","card__in":"styles_card__in__9own8"};